var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.7701 8.34109L17.1551 12.8376L18.244 19.1934C18.2884 19.4749 18.1773 19.749 17.9477 19.9194C17.8218 20.0157 17.6662 20.0601 17.5106 20.0601C17.3921 20.0601 17.2736 20.0305 17.1625 19.9786L11.4585 16.9785L5.75459 19.9786C5.50272 20.112 5.20641 20.0897 4.97678 19.9194C4.74714 19.7564 4.63602 19.4749 4.68047 19.1934L5.7694 12.8376L1.1618 8.34109C0.961791 8.14108 0.887714 7.85218 0.976607 7.5855C1.0655 7.31883 1.29514 7.11882 1.57663 7.08178L7.95468 6.15581L10.8066 0.377794C11.0585 -0.125931 11.8882 -0.125931 12.1326 0.377794L14.9846 6.15581L21.3626 7.08178C21.6441 7.12622 21.8738 7.31883 21.9627 7.5855C22.0516 7.85218 21.9775 8.14108 21.7701 8.34109Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/white-star.eae28a76314402517b07ac1da4406ae0.svg";
export { ForwardRef as ReactComponent };